import clsx from "clsx";
import { HorizontalLines } from "@/frontend/shared/assets/icons/HorizontalLines";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./EmptyPageContent.module.scss";
import { AddCompanies } from "@/frontend/features/Company/ui/AddCompanies/AddCompanies";
import { TCompanyInfo } from "@/frontend/pages/DashboardPage/model/types/types";
import { Dispatch, SetStateAction } from "react";
import { EContent } from "../DashboardHeader/types/types";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { MagnifyingGlassIcon } from "@/frontend/shared/assets/icons";
import { useNavigate } from "react-router-dom";
import { getRouteCompanies } from "@/frontend/shared/const/router";

export function EmptyPageContent({
  className,
  triggerRefetch,
  triggerRefetchAll,
  setBulkDataInfo,
  setFileUploadProgresses,
  setDashboardContent,
  stageOptions
}: {
  className?: string;
  triggerRefetch: () => void;
  triggerRefetchAll: () => void;
  setBulkDataInfo: Dispatch<SetStateAction<TCompanyInfo[]>>;
  setFileUploadProgresses: Dispatch<SetStateAction<Record<string, number>>>;
  setDashboardContent: Dispatch<SetStateAction<EContent>>;
  stageOptions: { label: string; value: string }[];
}) {
  const navigate = useNavigate();

  return (
    <div className={clsx(styles.container, className)}>
      <HorizontalLines className={styles.horizontalLines} />
      <Typography variant="heading-6" color="greyscale800" className={styles.header}>
        Streamline your investment pipeline
      </Typography>
      <Typography variant="body-2" color="greyscale700" className={styles.description}>
        Easily build and manage your pipeline by adding or discovering companies in our public directory{" "}
      </Typography>
      <div className={styles.buttonsContainer}>
        <AddCompanies
          triggerRefetch={triggerRefetch}
          triggerRefetchAll={triggerRefetchAll}
          setBulkDataInfo={setBulkDataInfo}
          setFileUploadProgresses={setFileUploadProgresses}
          setDashboardContent={setDashboardContent}
          isWhiteButton
          stageOptions={stageOptions}
        />
        <NormalButton
          className={styles.searchButton}
          variant="secondary"
          size="large"
          onClick={() => navigate(getRouteCompanies())}
        >
          <MagnifyingGlassIcon className={styles.searchIcon} />
          <Typography variant="label-4" color="greyscale700">
            Search Companies
          </Typography>
        </NormalButton>
      </div>
    </div>
  );
}
